export default function docReady(handler) {

  var newHandler = function () {
    // injects an event removal on the callback handler
    handler();
    if (document.addEventListener) {
      document.removeEventListener('DOMContentLoaded', newHandler);
    }
  }
  if (document.readyState != 'loading') {
    // already loaded
    newHandler();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', newHandler);
  } else {
    // mild backwards compat
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState == 'complete') {
        newHandler();
      }
    });
  }
};
